import { parseAirDateToISO } from '@air/utilities';

type ShouldGateUserForEmailVerificationParams = {
  accountCreatedAt?: string | null;
  cutoffIsoDate?: string;
  isEmailVerified?: boolean;
  workspaceCount?: number;
};

export const EMAIL_VERIFICATION_CUTOFF_DATE = '2026-05-13T00:00:00.000Z';

const parseDate = (dateValue?: string | null) => {
  if (!dateValue) {
    return null;
  }

  const parsedDate = parseAirDateToISO(dateValue);

  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export const shouldGateUserForEmailVerification = ({
  accountCreatedAt,
  cutoffIsoDate,
  isEmailVerified,
  workspaceCount = 0,
}: ShouldGateUserForEmailVerificationParams) => {
  if (isEmailVerified !== false) {
    return false;
  }

  if (workspaceCount > 0) {
    return false;
  }

  const cutoffDate = parseDate(cutoffIsoDate);
  const createdAtDate = parseDate(accountCreatedAt);

  if (!cutoffDate || !createdAtDate) {
    return false;
  }

  return createdAtDate.getTime() >= cutoffDate.getTime();
};
